import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from '../../fetch.js';
import { baseUrl, customHeaders, commsHeader, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';

import { GET_COMMS_REPORT_LIST, GET_COMMS_REPORT_SUCCESS, GET_COMMS_REPORT_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* getCommsReport({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/comms/tracker`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...commsHeader,
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({ type: GET_COMMS_REPORT_SUCCESS, payload: response?.data });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: GET_COMMS_REPORT_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: GET_COMMS_REPORT_ERROR, payload: error });
  }
}

export function* watchGetCommsReport() {
  yield takeEvery(GET_COMMS_REPORT_LIST, getCommsReport);
}

function* getCommsReportSaga() {
  yield all([fork(watchGetCommsReport)]);
}

export default getCommsReportSaga;
